import { render, staticRenderFns } from "./product_transfer.vue?vue&type=template&id=27e02804&scoped=true&"
import script from "./product_transfer.vue?vue&type=script&lang=js&"
export * from "./product_transfer.vue?vue&type=script&lang=js&"
import style0 from "./product_transfer.vue?vue&type=style&index=0&id=27e02804&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e02804",
  null
  
)

export default component.exports